/* eslint-disable no-console */
// Diagnostic only, gated behind REACT_APP_DEBUG_VOICE_RECORDING. Saves every clip we upload and
// logs what came back for it, so the audio behind a 409 can actually be listened to.

import audioFileExtension from "./audioFileExtension";

// Not `!!process.env...`: "0" and "false" are non-empty strings and would both read as ON, which
// is the one thing someone turning this off would try first.
const OFF_VALUES = ["", "0", "false"];
const enabled = !OFF_VALUES.includes(process.env.REACT_APP_DEBUG_VOICE_RECORDING ?? "");

const pad = (seq: number) => String(seq).padStart(3, "0");

const debugDownloadClip = (seq: number, blob: Blob): void => {
  if (!enabled) {
    return;
  }
  const name = `voice-clip-${pad(seq)}-${blob.size}b.${audioFileExtension(blob.type)}`;
  console.log(`[voice] clip ${pad(seq)} · ${blob.size} bytes · ${blob.type || "unknown type"}`);

  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.download = name;
  link.href = url;
  document.body.append(link);
  link.click();
  link.remove();
  // Revoking synchronously races the download in Firefox and Safari.
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
};

export const debugLogClipResult = (seq: number, transcript: string): void => {
  if (!enabled) {
    return;
  }
  console.log(`[voice] clip ${pad(seq)} → ${transcript === "" ? "(EMPTY / 409)" : transcript}`);
};

export default debugDownloadClip;
